import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as resetPasswordActions from './../ResetPassword/resetPasswordActions'; 

import Aux from './../../hoc/_Aux';

import { generateInputControls, onChangedHandler, generateForm } from './../../utils/form/generateFormTools';
import { validate } from './../../utils/form/validation';

class AskResetPasswordMailFrom extends Component {

    // defines inputs that belongs to the current form 
    elementsForForm = {
        username:{
            labelPosition: 'right',
            placeholder: 'Ton super pseudo',
            defaultValue: '' 
        },
        submit: {
            defaultValue: 'Envoyer' //submit needs value instead of label
        }
    };

    state = {
        controls: generateInputControls(['username', 'submit'], this.elementsForForm)
    }

    // routine legacy from generateFormTools.js
    inputChangedHandler = onChangedHandler;
    

    submitHandler = ( event ) => {
        event.preventDefault();

        const updatedControls = {...this.state.controls};
        const validation = validate( this.state.controls.username.value, this.state.controls.username.validation ); 
        var FormIsValid = true;        
        if(!validation['isValid']){
            FormIsValid = false;
            updatedControls.username = {
                ...this.state.controls.username,
                valid: validation['isValid'],
                errorMessage: validation['errorMessage'],
                touched: true
            };
        }

        if(FormIsValid){
            this.props.onReset(this.state.controls.username.value);
        }
        else if(this.state.controls.username.value === '')
        {
            this.props.onError('N\'oublie pas de renseigner ton pseudo');
        }
        else {
            this.props.onError('Vérifie ton pseudo, celui-ci semble ne pas convenir');
        }
 
    }

    render(){
        //const { hasError, errorMessage } = this.props;
        let form = generateForm(this, this.state.controls);

        return (
            <Aux>
                <form onSubmit={this.submitHandler} name={this.props.name} className={this.props.class}>
                    {form}
                </form>
            </Aux>
        );
    }
}

const mapStateToProps = state => {
    return {
        hasError: state.resetPassword.hasError,
        errorMessage: state.resetPassword.errorMessage
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onReset: ( username ) => dispatch(resetPasswordActions.sendResetPasswordMail(username)),
        onError: ( errorMessage ) => dispatch(resetPasswordActions.error(errorMessage))
    };
};

export default connect( mapStateToProps, mapDispatchToProps )(AskResetPasswordMailFrom);


// WEBPACK FOOTER //
// ./src/components/forms/askResetPasswordMailForm.js